
export const mockConversations = [
  // Private Chat 1 - Active conversation about drama
  {
    id: 'conv-1',
    created_at: new Date(Date.now() - 86400000 * 3).toISOString(),
    updated_at: new Date(Date.now() - 1800000).toISOString(),
    is_group: false,
    last_message: {
      id: 'msg-1-latest',
      content: 'The ending of episode 10 left me speechless! 😱',
      sender_id: 'user-2',
      created_at: new Date(Date.now() - 1800000).toISOString()
    },
    unread_count: 3,
    participants: [
      {
        user_id: 'user-1',
        user_profile: {
          id: 'user-1',
          username: 'You',
          avatar_url: ''
        }
      },
      {
        user_id: 'user-2',
        user_profile: {
          id: 'user-2',
          username: 'Amira Hassan',
          avatar_url: 'https://public.readdy.ai/ai/img_res/c661839fb2a99132d1cb0d380a92224c.jpg'
        }
      }
    ]
  },
  // Group Chat 1 - Noor Fan Club
  {
    id: 'group-1',
    created_at: new Date(Date.now() - 86400000 * 7).toISOString(),
    updated_at: new Date(Date.now() - 900000).toISOString(),
    is_group: true,
    group_name: 'Noor Fan Club ⭐',
    group_icon: 'ri-star-line',
    last_message: {
      id: 'gmsg-1-latest',
      content: 'Who else cried during the reunion scene? 😭',
      sender_id: 'user-5',
      created_at: new Date(Date.now() - 900000).toISOString()
    },
    unread_count: 8,
    participants: [
      {
        user_id: 'user-1',
        is_admin: true,
        user_profile: {
          id: 'user-1',
          username: 'You',
          avatar_url: ''
        }
      },
      {
        user_id: 'user-2',
        is_admin: false,
        user_profile: {
          id: 'user-2',
          username: 'Amira Hassan',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20middle%20eastern%20woman%20with%20warm%20smile%20wearing%20casual%20modern%20clothing%20against%20soft%20neutral%20background%20natural%20lighting%20friendly%20approachable%20expression&width=200&height=200&seq=amira-avatar-001&orientation=squarish'
        }
      },
      {
        user_id: 'user-3',
        is_admin: false,
        user_profile: {
          id: 'user-3',
          username: 'Yuki Tanaka',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20japanese%20woman%20with%20gentle%20smile%20wearing%20stylish%20casual%20outfit%20against%20clean%20minimalist%20background%20soft%20natural%20lighting&width=200&height=200&seq=yuki-avatar-001&orientation=squarish'
        }
      },
      {
        user_id: 'user-4',
        is_admin: false,
        user_profile: {
          id: 'user-4',
          username: 'Marcus Chen',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20asian%20man%20with%20confident%20smile%20wearing%20modern%20casual%20attire%20against%20neutral%20soft%20background%20natural%20daylight%20friendly%20demeanor&width=200&height=200&seq=marcus-avatar-001&orientation=squarish'
        }
      },
      {
        user_id: 'user-5',
        is_admin: false,
        user_profile: {
          id: 'user-5',
          username: 'Sofia Rodriguez',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20latina%20woman%20with%20bright%20smile%20wearing%20trendy%20casual%20clothing%20against%20warm%20neutral%20background%20natural%20lighting%20cheerful%20expression&width=200&height=200&seq=sofia-avatar-001&orientation=squarish'
        }
      },
      {
        user_id: 'user-6',
        is_admin: false,
        user_profile: {
          id: 'user-6',
          username: 'Elena Volkov',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20eastern%20european%20woman%20with%20elegant%20smile%20wearing%20sophisticated%20casual%20attire%20against%20soft%20gray%20background%20natural%20lighting&width=200&height=200&seq=elena-avatar-001&orientation=squarish'
        }
      }
    ]
  },
  // Private Chat 2 - Drama recommendations
  {
    id: 'conv-2',
    created_at: new Date(Date.now() - 86400000 * 5).toISOString(),
    updated_at: new Date(Date.now() - 3600000).toISOString(),
    is_group: false,
    last_message: {
      id: 'msg-2-latest',
      content: 'Thanks! I\'ll start watching tonight 🎬',
      sender_id: 'user-1',
      created_at: new Date(Date.now() - 3600000).toISOString()
    },
    unread_count: 0,
    participants: [
      {
        user_id: 'user-1',
        user_profile: {
          id: 'user-1',
          username: 'You',
          avatar_url: ''
        }
      },
      {
        user_id: 'user-3',
        user_profile: {
          id: 'user-3',
          username: 'Yuki Tanaka',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20japanese%20woman%20with%20gentle%20smile%20wearing%20stylish%20casual%20outfit%20against%20clean%20minimalist%20background%20soft%20natural%20lighting&width=200&height=200&seq=yuki-avatar-001&orientation=squarish'
        }
      }
    ]
  },
  // Group Chat 2 - AI Drama Reviewers
  {
    id: 'group-2',
    created_at: new Date(Date.now() - 86400000 * 14).toISOString(),
    updated_at: new Date(Date.now() - 7200000).toISOString(),
    is_group: true,
    group_name: 'AI Drama Reviewers 🎬',
    group_icon: 'ri-movie-2-line',
    last_message: {
      id: 'gmsg-2-latest',
      content: 'Just posted my review of Echoes of Tomorrow!',
      sender_id: 'user-4',
      created_at: new Date(Date.now() - 7200000).toISOString()
    },
    unread_count: 2,
    participants: [
      {
        user_id: 'user-1',
        is_admin: false,
        user_profile: {
          id: 'user-1',
          username: 'You',
          avatar_url: ''
        }
      },
      {
        user_id: 'user-4',
        is_admin: true,
        user_profile: {
          id: 'user-4',
          username: 'Marcus Chen',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20asian%20man%20with%20confident%20smile%20wearing%20modern%20casual%20attire%20against%20neutral%20soft%20background%20natural%20daylight%20friendly%20demeanor&width=200&height=200&seq=marcus-avatar-001&orientation=squarish'
        }
      },
      {
        user_id: 'user-6',
        is_admin: false,
        user_profile: {
          id: 'user-6',
          username: 'Elena Volkov',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20eastern%20european%20woman%20with%20elegant%20smile%20wearing%20sophisticated%20casual%20attire%20against%20soft%20gray%20background%20natural%20lighting&width=200&height=200&seq=elena-avatar-001&orientation=squarish'
        }
      },
      {
        user_id: 'user-7',
        is_admin: false,
        user_profile: {
          id: 'user-7',
          username: 'David Kim',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20korean%20man%20with%20friendly%20smile%20wearing%20smart%20casual%20outfit%20against%20clean%20white%20background%20natural%20lighting&width=200&height=200&seq=david-avatar-001&orientation=squarish'
        }
      }
    ]
  },
  // Private Chat 3 - Watch party planning
  {
    id: 'conv-3',
    created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
    updated_at: new Date(Date.now() - 14400000).toISOString(),
    is_group: false,
    last_message: {
      id: 'msg-3-latest',
      content: 'Perfect! Saturday 8pm works for me 👍',
      sender_id: 'user-4',
      created_at: new Date(Date.now() - 14400000).toISOString()
    },
    unread_count: 0,
    participants: [
      {
        user_id: 'user-1',
        user_profile: {
          id: 'user-1',
          username: 'You',
          avatar_url: ''
        }
      },
      {
        user_id: 'user-4',
        user_profile: {
          id: 'user-4',
          username: 'Marcus Chen',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20asian%20man%20with%20confident%20smile%20wearing%20modern%20casual%20attire%20against%20neutral%20soft%20background%20natural%20daylight%20friendly%20demeanor&width=200&height=200&seq=marcus-avatar-001&orientation=squarish'
        }
      }
    ]
  },
  // Private Chat 4 - New friend
  {
    id: 'conv-4',
    created_at: new Date(Date.now() - 86400000).toISOString(),
    updated_at: new Date(Date.now() - 28800000).toISOString(),
    is_group: false,
    last_message: {
      id: 'msg-4-latest',
      content: 'Nice to meet you! What dramas are you watching?',
      sender_id: 'user-5',
      created_at: new Date(Date.now() - 28800000).toISOString()
    },
    unread_count: 1,
    participants: [
      {
        user_id: 'user-1',
        user_profile: {
          id: 'user-1',
          username: 'You',
          avatar_url: ''
        }
      },
      {
        user_id: 'user-5',
        user_profile: {
          id: 'user-5',
          username: 'Sofia Rodriguez',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20latina%20woman%20with%20bright%20smile%20wearing%20trendy%20casual%20clothing%20against%20warm%20neutral%20background%20natural%20lighting%20cheerful%20expression&width=200&height=200&seq=sofia-avatar-001&orientation=squarish'
        }
      }
    ]
  },
  // Group Chat 3 - Weekend Watch Party
  {
    id: 'group-3',
    created_at: new Date(Date.now() - 86400000 * 3).toISOString(),
    updated_at: new Date(Date.now() - 43200000).toISOString(),
    is_group: true,
    group_name: 'Weekend Watch Party 🍿',
    group_icon: 'ri-tv-line',
    last_message: {
      id: 'gmsg-3-latest',
      content: 'Don\'t forget snacks! 🍕',
      sender_id: 'user-3',
      created_at: new Date(Date.now() - 43200000).toISOString()
    },
    unread_count: 0,
    participants: [
      {
        user_id: 'user-1',
        is_admin: true,
        user_profile: {
          id: 'user-1',
          username: 'You',
          avatar_url: ''
        }
      },
      {
        user_id: 'user-3',
        is_admin: false,
        user_profile: {
          id: 'user-3',
          username: 'Yuki Tanaka',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20japanese%20woman%20with%20gentle%20smile%20wearing%20stylish%20casual%20outfit%20against%20clean%20minimalist%20background%20soft%20natural%20lighting&width=200&height=200&seq=yuki-avatar-001&orientation=squarish'
        }
      },
      {
        user_id: 'user-5',
        is_admin: false,
        user_profile: {
          id: 'user-5',
          username: 'Sofia Rodriguez',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20latina%20woman%20with%20bright%20smile%20wearing%20trendy%20casual%20clothing%20against%20warm%20neutral%20background%20natural%20lighting%20cheerful%20expression&width=200&height=200&seq=sofia-avatar-001&orientation=squarish'
        }
      }
    ]
  },
  // Private Chat 5 - Elena discussion
  {
    id: 'conv-5',
    created_at: new Date(Date.now() - 86400000 * 4).toISOString(),
    updated_at: new Date(Date.now() - 86400000).toISOString(),
    is_group: false,
    last_message: {
      id: 'msg-5-latest',
      content: 'The cinematography in that scene was breathtaking!',
      sender_id: 'user-6',
      created_at: new Date(Date.now() - 86400000).toISOString()
    },
    unread_count: 0,
    participants: [
      {
        user_id: 'user-1',
        user_profile: {
          id: 'user-1',
          username: 'You',
          avatar_url: ''
        }
      },
      {
        user_id: 'user-6',
        user_profile: {
          id: 'user-6',
          username: 'Elena Volkov',
          avatar_url: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20eastern%20european%20woman%20with%20elegant%20smile%20wearing%20sophisticated%20casual%20attire%20against%20soft%20gray%20background%20natural%20lighting&width=200&height=200&seq=elena-avatar-001&orientation=squarish'
        }
      }
    ]
  }
]

export const mockMessages: Record<string, any[]> = {
  'conv-1': [
    {
      id: 'msg-1-1',
      conversation_id: 'conv-1',
      sender_id: 'user-2',
      content: 'Hey! Have you started watching Noor yet?',
      created_at: new Date(Date.now() - 86400000 * 3).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-1-2',
      conversation_id: 'conv-1',
      sender_id: 'user-1',
      content: 'Yes! I\'m on episode 5 now. It\'s so good!',
      created_at: new Date(Date.now() - 86400000 * 3 + 300000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-1-3',
      conversation_id: 'conv-1',
      sender_id: 'user-2',
      content: 'Right?! The character development is amazing 💯',
      created_at: new Date(Date.now() - 86400000 * 3 + 600000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-1-4',
      conversation_id: 'conv-1',
      sender_id: 'user-1',
      content: 'I love how they revealed the backstory slowly',
      created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-1-5',
      conversation_id: 'conv-1',
      sender_id: 'user-2',
      content: 'Wait until you get to episode 8! 🔥',
      created_at: new Date(Date.now() - 86400000 * 2 + 180000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-1-6',
      conversation_id: 'conv-1',
      sender_id: 'user-1',
      content: 'No spoilers please! 😅',
      created_at: new Date(Date.now() - 86400000 * 2 + 360000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-1-7',
      conversation_id: 'conv-1',
      sender_id: 'user-2',
      content: 'Haha okay okay! Just enjoy the ride 🎢',
      created_at: new Date(Date.now() - 86400000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-1-8',
      conversation_id: 'conv-1',
      sender_id: 'user-2',
      content: 'Did you finish episode 9?',
      created_at: new Date(Date.now() - 7200000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-1-9',
      conversation_id: 'conv-1',
      sender_id: 'user-1',
      content: 'Just finished! That cliffhanger though...',
      created_at: new Date(Date.now() - 5400000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-1-latest',
      conversation_id: 'conv-1',
      sender_id: 'user-2',
      content: 'The ending of episode 10 left me speechless! 😱',
      created_at: new Date(Date.now() - 1800000).toISOString(),
      is_deleted: false
    }
  ],
  'group-1': [
    {
      id: 'gmsg-1-1',
      conversation_id: 'group-1',
      sender_id: 'user-1',
      content: 'Created group "Noor Fan Club ⭐"',
      created_at: new Date(Date.now() - 86400000 * 7).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-2',
      conversation_id: 'group-1',
      sender_id: 'user-2',
      content: 'Hey everyone! So excited to be here 🎉',
      created_at: new Date(Date.now() - 86400000 * 7 + 3600000).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-3',
      conversation_id: 'group-1',
      sender_id: 'user-4',
      content: 'This is the best drama of the year!',
      created_at: new Date(Date.now() - 86400000 * 6).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-4',
      conversation_id: 'group-1',
      sender_id: 'user-3',
      content: 'The AI-generated visuals are incredible',
      created_at: new Date(Date.now() - 86400000 * 5).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-5',
      conversation_id: 'group-1',
      sender_id: 'user-6',
      content: 'I\'ve rewatched episode 5 three times already 😂',
      created_at: new Date(Date.now() - 86400000 * 4).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-6',
      conversation_id: 'group-1',
      sender_id: 'user-1',
      content: 'Who\'s your favorite character?',
      created_at: new Date(Date.now() - 86400000 * 3).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-7',
      conversation_id: 'group-1',
      sender_id: 'user-5',
      content: 'Definitely Layla! Her arc is so well written',
      created_at: new Date(Date.now() - 86400000 * 3 + 1800000).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-8',
      conversation_id: 'group-1',
      sender_id: 'user-2',
      content: 'I love Omar! His redemption story is beautiful',
      created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-9',
      conversation_id: 'group-1',
      sender_id: 'user-4',
      content: 'New episode drops tomorrow! 🙌',
      created_at: new Date(Date.now() - 86400000).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-10',
      conversation_id: 'group-1',
      sender_id: 'user-3',
      content: 'Can\'t wait! Setting my alarm ⏰',
      created_at: new Date(Date.now() - 43200000).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-11',
      conversation_id: 'group-1',
      sender_id: 'user-6',
      content: 'Let\'s do a live watch together!',
      created_at: new Date(Date.now() - 21600000).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-1-latest',
      conversation_id: 'group-1',
      sender_id: 'user-5',
      content: 'Who else cried during the reunion scene? 😭',
      created_at: new Date(Date.now() - 900000).toISOString(),
      is_deleted: false
    }
  ],
  'conv-2': [
    {
      id: 'msg-2-1',
      conversation_id: 'conv-2',
      sender_id: 'user-3',
      content: 'Hi! I saw your post about AI dramas',
      created_at: new Date(Date.now() - 86400000 * 5).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-2-2',
      conversation_id: 'conv-2',
      sender_id: 'user-1',
      content: 'Hey Yuki! Yes, I\'m always looking for recommendations',
      created_at: new Date(Date.now() - 86400000 * 5 + 600000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-2-3',
      conversation_id: 'conv-2',
      sender_id: 'user-3',
      content: 'You should definitely check out "Echoes of Tomorrow"',
      created_at: new Date(Date.now() - 86400000 * 4).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-2-4',
      conversation_id: 'conv-2',
      sender_id: 'user-3',
      content: 'It\'s a sci-fi drama with amazing AI visuals',
      created_at: new Date(Date.now() - 86400000 * 4 + 120000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-2-5',
      conversation_id: 'conv-2',
      sender_id: 'user-1',
      content: 'Sounds interesting! How many episodes?',
      created_at: new Date(Date.now() - 86400000 * 3).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-2-6',
      conversation_id: 'conv-2',
      sender_id: 'user-3',
      content: '12 episodes, each about 45 minutes',
      created_at: new Date(Date.now() - 86400000 * 3 + 300000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-2-7',
      conversation_id: 'conv-2',
      sender_id: 'user-3',
      content: 'The plot twists are incredible! 🌟',
      created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-2-latest',
      conversation_id: 'conv-2',
      sender_id: 'user-1',
      content: 'Thanks! I\'ll start watching tonight 🎬',
      created_at: new Date(Date.now() - 3600000).toISOString(),
      is_deleted: false
    }
  ],
  'group-2': [
    {
      id: 'gmsg-2-1',
      conversation_id: 'group-2',
      sender_id: 'user-4',
      content: 'Created group "AI Drama Reviewers 🎬"',
      created_at: new Date(Date.now() - 86400000 * 14).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-2-2',
      conversation_id: 'group-2',
      sender_id: 'user-6',
      content: 'Great idea for a group! Looking forward to discussions',
      created_at: new Date(Date.now() - 86400000 * 14 + 7200000).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-2-3',
      conversation_id: 'group-2',
      sender_id: 'user-1',
      content: 'Happy to be here! I love analyzing dramas',
      created_at: new Date(Date.now() - 86400000 * 13).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-2-4',
      conversation_id: 'group-2',
      sender_id: 'user-7',
      content: 'Should we create a rating system?',
      created_at: new Date(Date.now() - 86400000 * 10).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-2-5',
      conversation_id: 'group-2',
      sender_id: 'user-4',
      content: 'Good idea! Let\'s rate on story, visuals, and acting',
      created_at: new Date(Date.now() - 86400000 * 10 + 3600000).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-2-6',
      conversation_id: 'group-2',
      sender_id: 'user-6',
      content: 'Don\'t forget soundtrack! Music is so important',
      created_at: new Date(Date.now() - 86400000 * 7).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-2-7',
      conversation_id: 'group-2',
      sender_id: 'user-1',
      content: 'Agreed! The OST can make or break a drama',
      created_at: new Date(Date.now() - 86400000 * 5).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-2-8',
      conversation_id: 'group-2',
      sender_id: 'user-7',
      content: 'Anyone watched "Digital Hearts" yet?',
      created_at: new Date(Date.now() - 86400000 * 3).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-2-9',
      conversation_id: 'group-2',
      sender_id: 'user-6',
      content: 'Yes! I\'d give it 8/10 for visuals',
      created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-2-latest',
      conversation_id: 'group-2',
      sender_id: 'user-4',
      content: 'Just posted my review of Echoes of Tomorrow!',
      created_at: new Date(Date.now() - 7200000).toISOString(),
      is_deleted: false
    }
  ],
  'conv-3': [
    {
      id: 'msg-3-1',
      conversation_id: 'conv-3',
      sender_id: 'user-4',
      content: 'Hey! Want to do a watch party this weekend?',
      created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-3-2',
      conversation_id: 'conv-3',
      sender_id: 'user-1',
      content: 'That sounds fun! What should we watch?',
      created_at: new Date(Date.now() - 86400000 * 2 + 1800000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-3-3',
      conversation_id: 'conv-3',
      sender_id: 'user-4',
      content: 'How about the new episodes of Noor?',
      created_at: new Date(Date.now() - 86400000 * 2 + 3600000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-3-4',
      conversation_id: 'conv-3',
      sender_id: 'user-1',
      content: 'Perfect! I\'m caught up to episode 8',
      created_at: new Date(Date.now() - 86400000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-3-5',
      conversation_id: 'conv-3',
      sender_id: 'user-4',
      content: 'Great! Saturday evening work for you?',
      created_at: new Date(Date.now() - 86400000 + 7200000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-3-latest',
      conversation_id: 'conv-3',
      sender_id: 'user-4',
      content: 'Perfect! Saturday 8pm works for me 👍',
      created_at: new Date(Date.now() - 14400000).toISOString(),
      is_deleted: false
    }
  ],
  'conv-4': [
    {
      id: 'msg-4-1',
      conversation_id: 'conv-4',
      sender_id: 'user-5',
      content: 'Hi! I saw you in the Noor Fan Club group',
      created_at: new Date(Date.now() - 86400000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-4-2',
      conversation_id: 'conv-4',
      sender_id: 'user-1',
      content: 'Hey Sofia! Yes, I\'m a big fan of the show',
      created_at: new Date(Date.now() - 86400000 + 1800000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-4-3',
      conversation_id: 'conv-4',
      sender_id: 'user-5',
      content: 'Me too! It\'s my first AI drama and I\'m hooked',
      created_at: new Date(Date.now() - 86400000 + 3600000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-4-latest',
      conversation_id: 'conv-4',
      sender_id: 'user-5',
      content: 'Nice to meet you! What dramas are you watching?',
      created_at: new Date(Date.now() - 28800000).toISOString(),
      is_deleted: false
    }
  ],
  'group-3': [
    {
      id: 'gmsg-3-1',
      conversation_id: 'group-3',
      sender_id: 'user-1',
      content: 'Created group "Weekend Watch Party 🍿"',
      created_at: new Date(Date.now() - 86400000 * 3).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-3-2',
      conversation_id: 'group-3',
      sender_id: 'user-3',
      content: 'Yay! Can\'t wait for Saturday!',
      created_at: new Date(Date.now() - 86400000 * 3 + 3600000).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-3-3',
      conversation_id: 'group-3',
      sender_id: 'user-5',
      content: 'What time are we starting?',
      created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-3-4',
      conversation_id: 'group-3',
      sender_id: 'user-1',
      content: 'How about 8pm? That way everyone can join',
      created_at: new Date(Date.now() - 86400000 * 2 + 1800000).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-3-5',
      conversation_id: 'group-3',
      sender_id: 'user-5',
      content: 'Works for me! 🙌',
      created_at: new Date(Date.now() - 86400000).toISOString(),
      is_deleted: false
    },
    {
      id: 'gmsg-3-latest',
      conversation_id: 'group-3',
      sender_id: 'user-3',
      content: 'Don\'t forget snacks! 🍕',
      created_at: new Date(Date.now() - 43200000).toISOString(),
      is_deleted: false
    }
  ],
  'conv-5': [
    {
      id: 'msg-5-1',
      conversation_id: 'conv-5',
      sender_id: 'user-6',
      content: 'Hi! I read your review on the forum',
      created_at: new Date(Date.now() - 86400000 * 4).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-5-2',
      conversation_id: 'conv-5',
      sender_id: 'user-1',
      content: 'Thanks Elena! Which one did you read?',
      created_at: new Date(Date.now() - 86400000 * 4 + 3600000).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-5-3',
      conversation_id: 'conv-5',
      sender_id: 'user-6',
      content: 'The one about Echoes of Tomorrow. Great analysis!',
      created_at: new Date(Date.now() - 86400000 * 3).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-5-4',
      conversation_id: 'conv-5',
      sender_id: 'user-1',
      content: 'Thank you! The visual storytelling in that drama is exceptional',
      created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
      is_deleted: false
    },
    {
      id: 'msg-5-latest',
      conversation_id: 'conv-5',
      sender_id: 'user-6',
      content: 'The cinematography in that scene was breathtaking!',
      created_at: new Date(Date.now() - 86400000).toISOString(),
      is_deleted: false
    }
  ]
}
